import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDriverRevenueReport extends Layout {
    excludabletextboxDriver: ExcludableTextbox;
    excludabletextboxFleet: ExcludableTextbox;
    excludabletextboxFleetManager: ExcludableTextbox;
    excludabletextboxSteamship: ExcludableTextbox;
    sourceDriverRevenue: DataSource;
    switchIncludeFuel: Switch;
    switchReportType: Switch;
    switchincludeRemaining: Switch;
    textboxDateRange: Textbox;
    textboxDateType: Textbox;
    textboxGoupBy: Textbox;
    textboxInclude: Textbox;
}
